module.exports = __webpack_public_path__ + "static/media/signinpagebackground.bb62d06d.png";